import { jsonValueSchema } from './json.ts';
import type { JsonValue } from './json.ts';

export type FieldPatch = { path: string[]; value?: JsonValue; remove?: boolean };
function record(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function objectPatches(before: object, after: object): FieldPatch[] {
  const patches: FieldPatch[] = [];
  const visit = (before: unknown, after: unknown, path: string[]): void => {
    if (JSON.stringify(before) === JSON.stringify(after)) return;
    if (record(before) && record(after)) {
      for (const key of new Set([...Object.keys(before), ...Object.keys(after)]))
        visit(before[key], after[key], [...path, key]);
    } else
      patches.push(
        after === undefined
          ? { path, remove: true }
          : { path, value: jsonValueSchema.parse(JSON.parse(JSON.stringify(after))) },
      );
  };
  visit(before, after, []);
  return patches;
}

export function applyObjectPatches<T extends object>(value: T, patches: FieldPatch[]): T {
  const result = structuredClone(value) as Record<string, unknown>;
  for (const patch of patches) {
    let target = result;
    for (const part of patch.path.slice(0, -1)) {
      if (!record(target[part])) target[part] = {};
      target = target[part] as Record<string, unknown>;
    }
    const key = patch.path.at(-1)!;
    if (patch.remove) delete target[key];
    else target[key] = structuredClone(patch.value);
  }
  return result as T;
}
